/** HMAC-SHA256 ในเบราว์เซอร์ (Web Crypto) → hex string */
export const hmacSha256 = async (key: string, message: string): Promise<string> => {
  const encoder = new TextEncoder();
  const keyData = encoder.encode(key);
  const msgData = encoder.encode(message);
  const cryptoKey = await crypto.subtle.importKey('raw', keyData, { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
  const signature = await crypto.subtle.sign('HMAC', cryptoKey, msgData);
  return Array.from(new Uint8Array(signature)).map(b => b.toString(16).padStart(2, '0')).join('');
};

// ⚠️ SORT-KEY (เรียงลำดับ key) — ยังไม่ได้ใช้งานตอนนี้
// ปัจจุบัน signature ฝั่ง backend (middleware/signatureAuth.js) verify ด้วย
//   JSON.stringify(req.body) โดย "คงลำดับ key ตามที่รับมา" — ไม่มีการ sort
// ดังนั้นห้ามเรียก sortKeysDeep ตอนเซ็น มิฉะนั้น signature จะไม่ตรง
//
// TODO (ถ้าจะเปลี่ยนไปใช้สคีมแบบเรียง key ในอนาคต):
//   1. ฝั่ง client: เซ็นด้วย JSON.stringify(sortKeysDeep(reqBody)) และ "ส่ง body ตัวเดียวกันนี้"
//   2. ฝั่ง backend: buildSignaturePayload ต้อง JSON.stringify(sortKeysDeep(req.body)) ให้ตรงกัน
//   ต้องแก้พร้อมกันทั้ง 2 ฝั่ง ไม่งั้น verify ไม่ผ่าน
export const sortKeysDeep = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(sortKeysDeep);
  if (value !== null && typeof value === 'object') {
    return Object.keys(value as object).sort().reduce((acc: Record<string, unknown>, key) => {
      acc[key] = sortKeysDeep((value as Record<string, unknown>)[key]);
      return acc;
    }, {});
  }
  return value;
};
